// Resolves the backend API base URL.
//
// Behavior:
// - If REACT_APP_BACKEND_URL matches the current page origin (typical preview
//   environment), use it as-is.
// - Otherwise (e.g. a production build deployed to a custom domain whose
//   baked-in env still points at the preview), fall back to same-origin
//   relative paths so the frontend always talks to the host that served it.
//   This prevents production deployments from accidentally hitting the
//   preview backend (and database).
import logger from './logger';

export function getApiBase() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
  if (typeof window === 'undefined') return envUrl;
  try {
    const origin = window.location.origin;
    if (envUrl && envUrl.startsWith(origin)) return envUrl;
  } catch (err) {
    logger.warn('apiBase: window.location.origin unavailable', err);
  }
  // Same-origin relative — works for both Emergent preview and production
  // ingress because both route `/api/*` to the FastAPI service.
  return '';
}

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;
